interface SkeletonProps {
 className?: string;
}

function Skeleton({ className }: SkeletonProps) {
 return <div className={`animate-pulse bg-muted rounded-lg ${className ?? ""}`} />;
}

export function HeroSkeleton() {
 return (
 <section className="gradient-bg py-16 lg:py-24">
 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
 <div className="max-w-3xl">
 <Skeleton className="h-5 w-32 mb-6" />
 <Skeleton className="h-14 w-full mb-3" />
 <Skeleton className="h-14 w-3/4 mb-6" />
 <Skeleton className="h-5 w-full mb-2" />
 <Skeleton className="h-5 w-2/3" />
 </div>
 </div>
 </section>
 );
}

export function ContentSkeleton() {
 return (
 <div className="py-12">
 <div className="space-y-4">
 <Skeleton className="h-4 w-full" />
 <Skeleton className="h-4 w-full" />
 <Skeleton className="h-4 w-5/6" />
 <Skeleton className="h-4 w-full" />
 <Skeleton className="h-4 w-4/5" />
 <Skeleton className="h-4 w-full" />
 <Skeleton className="h-4 w-3/4" />
 </div>
 </div>
 );
}

export function GridSkeleton({ count = 6 }: { count?: number }) {
 return (
 <div className="py-12">
 <Skeleton className="h-8 w-48 mb-8" />
 <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
 {Array.from({ length: count }).map((_, i) => (
 <div key={i} className="border border-border rounded-xl p-6">
 <Skeleton className="h-10 w-10 rounded-lg mb-4" />
 <Skeleton className="h-5 w-3/4 mb-2" />
 <Skeleton className="h-4 w-full mb-1" />
 <Skeleton className="h-4 w-2/3" />
 </div>
 ))}
 </div>
 </div>
 );
}

export function SidebarSkeleton() {
 return (
 <div className="space-y-6">
 <div className="bg-muted rounded-xl p-5">
 <Skeleton className="h-4 w-24 mb-4" />
 <div className="space-y-2">
 <Skeleton className="h-3 w-full" />
 <Skeleton className="h-3 w-5/6" />
 <Skeleton className="h-3 w-4/5" />
 <Skeleton className="h-3 w-full" />
 </div>
 </div>
 </div>
 );
}

export function PageSkeleton() {
 return (
 <>
 <HeroSkeleton />
 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
 <ContentSkeleton />
 <GridSkeleton />
 </div>
 </>
 );
}
